import type { ZoomOptionsInterface } from '@nts/std/interfaces';
import { FindValuesOptions } from './find-values-options';

export class ZoomOptions extends FindValuesOptions implements ZoomOptionsInterface {

    constructor() {
        super();

        this.take = 200;
        this.skip = 0;
    }
}
